var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesign000000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8716 7.03189L63.0329 1.17729C62.3517 0.466482 61.4232 0.0449459 60.4397 1.14813e-05H60.3284C59.8265 -0.00121923 59.3293 0.096505 58.8652 0.287595C58.4011 0.478685 57.9793 0.759391 57.6238 1.11366L7.47787 51.3391L0.143717 67.8211C0.0433538 68.0292 -0.00574097 68.2583 0.000534117 68.4893C0.000534117 68.9112 0.168149 69.3159 0.466505 69.6142C0.764861 69.9126 1.16952 70.0802 1.59146 70.0802C1.81205 70.0994 2.03421 70.0723 2.24374 70.0007L18.7257 62.6665L68.8716 12.4251C69.229 12.0728 69.5128 11.653 69.7065 11.1901C69.9002 10.7272 70 10.2303 70 9.72851C70 9.22668 69.9002 8.72986 69.7065 8.26692C69.5128 7.80399 69.229 7.38418 68.8716 7.03189ZM9.80062 53.2482L16.8484 60.296L10.7552 63.0165L7.04833 59.3415L9.80062 53.2482ZM66.8512 10.4047L63.0011 14.3183L55.7942 7.11144L59.6602 3.18186C59.7458 3.09062 59.8493 3.01807 59.9643 2.96879C60.0793 2.91951 60.2033 2.89455 60.3284 2.89549C60.575 2.90153 60.8093 3.0044 60.9806 3.18186L66.8193 9.02055C66.9914 9.19557 67.0933 9.42767 67.1057 9.67283C67.1158 9.80575 67.0984 9.93934 67.0546 10.0652C67.0108 10.1912 66.9416 10.3067 66.8512 10.4047Z",
    fill: "#000000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign000000);
export default __webpack_public_path__ + "static/media/design_000000.dd41df4ce79430d0150de2a17f48380e.svg";
export { ForwardRef as ReactComponent };